import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { DbtJobModels } from "./DbtJobModels";

export const DbtJobModelsWithProvider = () => (
  <DatatableContextProvider>
    <DbtJobModels />
  </DatatableContextProvider>
);
